<template>
  <div>
    <!-- 関連市町村 -->
    <div v-for="(value, key) in showTownPolygon" v-bind:key="key">
      <l-geo-json :geojson="value" :options="options" pane="townPane" />
    </div>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import { LGeoJson } from "vue2-leaflet";
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 関連市町村レイヤー
 * TownPolygonLayer.vue
 * @author LIS
 */

export default {
  name: "town-polygon-layer",
  components: {
    LGeoJson,
  },
  /** 初期化部 */
  mounted() {
    // 関連市町村Polygonを取得
    this.getTownPolygon();
  },
  /** 算出部 */
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** 最新の危険度 */
    getLvl: {
      get() {
        let lvl = 0;
        const type = this.$store.state.RiverWarn.selectedWarnType;
        if (type == 10) {
          // 洪水予報
          // 選択中河川予警報データのリストは発表番号の降順で並んでいるため、先頭が最新となる
          lvl = this.$store.state.RiverWarn.selectedRwDetail.rw[0].fldfrLvl;
        } else if (type == 11) {
          // 水位周知
          lvl = this.$store.state.RiverWarn.selectedRwDetail.rw[0].evstgLvl;
        } else if (type == 20) {
          // 水防警報
          lvl = this.$store.state.RiverWarn.selectedRwDetail.rw[0].fldctlLvl;
        } else if (type == 30) {
          // ダム放流通知
          lvl = this.$store.state.RiverWarn.selectedRwDetail.rw[0].damdschLvl;
        }
        return lvl;
      },
    },
    // 選択中の発表番号の河川予警報データの都道府県リスト
    selectedWarnPrefTwn: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.mt.prefTwn;
      },
    },
    /** 関連市町村Polygonを取得する */
    showTownPolygon: {
      get() {
        return this.$store.state.map.townPolygon;
      },
    },
    /** 表示設定 */
    options: {
      get() {
        return {
          style: () => {
            let color = null;
            const type = this.$store.state.RiverWarn.selectedWarnType;

            if (type == 10) {
              // 洪水予報
              if (this.getLvl == 90) {
                color = Color.rwStgOver;
              } else if (this.getLvl == 80) {
                color = Color.rwStgDanger;
              } else if (this.getLvl == 60) {
                color = Color.rwStgRefuge;
              } else if (this.getLvl == 30) {
                color = Color.rwStgWarn;
              }
            } else if (type == 11) {
              // 水位周知
              if (this.getLvl == 90) {
                color = Color.rwStgOver;
              } else if (this.getLvl == 80) {
                color = Color.rwStgDanger;
              } else if (this.getLvl == 60) {
                color = Color.rwStgRefuge;
              } else if (this.getLvl == 30) {
                color = Color.rwStgWarn;
              }
            } else if (type == 20) {
              // 水防警報
              if (this.getLvl == 40) {
                color = Color.rwFldctlDispatch;
              } else if (this.getLvl == 20) {
                color = Color.rwFldctlPreparation;
              } else if (this.getLvl == 10) {
                color = Color.rwFldctlStandby;
              }
            } else if (type == 30) {
              // ダム放流通知
              if (this.getLvl == 70) {
                color = Color.rwDamdschPrevop;
              } else if (this.getLvl == 50) {
                color = Color.rwDamdschStorop;
              }
            }

            let dTOption = {
              color: color,
              weight: this.mapConfig.townPolygon.weight,
              opacity: this.mapConfig.townPolygon.opacity,
              fillOpacity: this.mapConfig.townPolygon.fillOpacity,
            };
            return dTOption;
          },
          filter: () => {
            if (this.getLvl > 0) {
              return true;
            }
            return false;
          },
        };
      },
    },
  },
  methods: {
    /**
     * 関連市町村Polygonを取得
     */
    getTownPolygon() {
      let towns = [];
      // 選択中の発表番号の河川予警報データの都道府県リスト
      const targetPlefList = this.selectedWarnPrefTwn;

      // 選択中河川予警報データの都道府県の数だけ処理を繰り返す
      for (var i = 0; i < targetPlefList.length; i++) {
        // 選択中河川予警報データの市町村の数だけ処理を繰り返す
        for (var j = 0; j < targetPlefList[i].twn.length; j++) {
          // 関連市町村リストを作成する
          towns.push(targetPlefList[i].twn[j].twnCd);
        }
      }
      // 関連市町村Polygonを取得する
      this.$store.dispatch("map/getTownPolygon", towns);
    },
  },
  watch: {
    selectedWarnPrefTwn() {
      // 関連市町村Polygonを取得
      this.getTownPolygon();
    },
  },
};
</script>
